import{ memo } from "react";
import PostJobFormPage from "../postJobFormPage";

const EmployerHomePage = () =>{
    return (
        <PostJobFormPage/>
    );
}

export default memo(EmployerHomePage);